import { Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';

const roleLabel = (approverRole, approvalStage, approvalStatus) => {
  if (approverRole === 'FINANCE' || approvalStage === 'FINANCE') {
    return 'Finance';
  }
  if (
    approverRole === 'SENIOR_MANAGER' ||
    approvalStage === 'SENIOR_MANAGER' ||
    approvalStatus === 'SENIOR_MANAGER_APPROVED'
  ) {
    return 'Senior Manager';
  }
  if (approvalStatus === 'MANAGER_APPROVED') {
    return 'Manager (Legacy)';
  }
  if (approvalStatus === 'APPROVED' && !approverRole && !approvalStage) {
    return 'Approver';
  }
  return null;
};

const EHApprovalStatus = (Props) => {
  const {
    approverName,
    approverComments,
    updatedOn,
    approvalStatus,
    approvalStage,
    approverRole,
  } = Props;

  const role = roleLabel(approverRole, approvalStage, approvalStatus);
  const displayName = role
    ? `${approverName || 'Unknown'} (${role})`
    : approverName || 'Unknown';

  const isPositive =
    approvalStatus === 'APPROVED' ||
    approvalStatus === 'MANAGER_APPROVED' ||
    approvalStatus === 'SENIOR_MANAGER_APPROVED';

  return (
    <>
      <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Grid item xs={12} sm={3} md={2}>
          <Typography sx={{ fontWeight: { xs: 'bold', md: 'unset' } }}>
            {displayName}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={4} md={5}>
          <Tooltip title={approverComments || 'No Comments'}>
            <Typography
              noWrap
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {approverComments || 'No Comments'}
            </Typography>
          </Tooltip>
        </Grid>

        <Grid item xs={5} sm={3} md={3} sx={{ textAlign: 'center' }}>
          <Typography>{updatedOn || 'Not Replied Yet'}</Typography>
        </Grid>

        <Grid item xs={3} sm={1} md={1} sx={{ textAlign: 'right' }}>
          {isPositive ? (
            <CheckCircleOutlineIcon color="success" />
          ) : approvalStatus === 'REJECTED' ? (
            <CancelOutlinedIcon color="error" />
          ) : (
            <HourglassTopOutlinedIcon color="warning" />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default EHApprovalStatus;
